<div id="change-password" class="profile-box info-box flex flex-col">
  <header class="accent">
    <div i18n class="title">Изменение пароля</div>
  </header>

  <div class="content">
    <form
      name="resetPasswordForm"
      [formGroup]="resetPasswordForm"
      (ngSubmit)="onSubmit()"
      novalidate
      class="flex flex-col">
      <mat-form-field>
        <input
          i18n-placeholder
          matInput
          placeholder="Новый пароль"
          formControlName="newPassword"
          [type]="hideNewPass ? 'password' : 'text'" />
        <mat-icon matSuffix class="hide-btn" (click)="hideNewPass = !hideNewPass">
          {{ hideNewPass ? 'visibility' : 'visibility_off' }}</mat-icon
        >
        <mat-error i18n *ngIf="resetPasswordFormErrors.newPassword.required">Пароль не задан</mat-error>
        <mat-error
          i18n
          *ngIf="!resetPasswordFormErrors.newPassword.required && resetPasswordFormErrors.newPassword.minLength"
          >Минимальная длина - {{ resetPasswordFormErrors.newPassword.minlength.requiredLength }}</mat-error
        >
      </mat-form-field>

      <mat-form-field>
        <input
          i18n-placeholder
          matInput
          placeholder="Старый пароль"
          formControlName="oldPassword"
          [type]="hideOldPass ? 'password' : 'text'" />
        <mat-icon matSuffix class="hide-btn" (click)="hideOldPass = !hideOldPass">
          {{ hideOldPass ? 'visibility' : 'visibility_off' }}</mat-icon
        >
        <mat-error i18n *ngIf="resetPasswordFormErrors.oldPassword.required">Пароль не задан</mat-error>
      </mat-form-field>

      <button
        i18n
        mat-raised-button
        class="mx-16"
        color="accent"
        type="submit"
        aria-label="RESET MY PASSWORD"
        [disabled]="resetPasswordForm.invalid"
        >ИЗМЕНИТЬ ПАРОЛЬ</button
      >
    </form>
  </div>
</div>
